// extracted by mini-css-extract-plugin
export default {"flatButton":"flat-button_flatButton__hkOYv"};